import styled from 'styled-components';

import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

export default styled.span`
    border-radius: ${({ theme }: ThemedProperties) => `${theme.radii.percentage.half}%`};
    background-color: ${({ theme }: ThemedProperties) => `${theme.colors.system.background}`};

    padding: ${({ theme }: ThemedProperties) => `${theme.indents.xxs}px`};
`;
